module.exports = __webpack_public_path__ + "static/media/login-bg.70f76c10.webp";